import type { FiltersProps } from '../../Entities/Search/SearchFilters/LocationFilter/LocationFilter.entity';

const LOCATION_FILTER_KEYS = ['postcode', 'lat', 'lon'];

const POSTCODE_KEY = 'postcode';
const FILTERS_PROPS: FiltersProps = [
  {
    key: 'lat',
    isMainFilterKey: false,
    filterType: POSTCODE_KEY,
  },
  {
    key: 'lon',
    isMainFilterKey: false,
    filterType: POSTCODE_KEY,
  },
  {
    key: POSTCODE_KEY,
    isMainFilterKey: true,
    filterType: POSTCODE_KEY,
  },
  {
    key: 'max-distance',
    isMainFilterKey: false,
    filterType: POSTCODE_KEY,
  },
];

export { POSTCODE_KEY, LOCATION_FILTER_KEYS, FILTERS_PROPS };
